import { websiteLabel } from 'utils/faq-sponsor';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

// Paid placement, so every link in it says so to search engines.
const SPONSORED_REL = 'sponsored nofollow';

// The API only stores web addresses; this keeps any other scheme out of an href.
const webHref = (url) => (/^https?:\/\//i.test(url || '') ? url : null);

// Evergreen Sponsor: the story's five questions, answered by the expert who
// paid for the slot. Rendered on the server with the story; no FAQPage
// markup, since Google keeps FAQ results for government and health sites and
// this is sponsored content.
const ExpertAnswers = ({ answers }) => {
    const { heading, items, sponsor } = answers;
    const website = webHref(sponsor.website);
    const firm = websiteLabel(sponsor.firm, website);

    return (
        <section className={styles.expertAnswers} aria-label="Expert answers">
            <span className={styles.sponsoredLabel}>Sponsored</span>
            <h2 className={styles.expertAnswersHeading}>{heading}</h2>
            <p className={styles.expertAnswersIntro}>
                Answers from{' '}
                {sponsor.profileSlug ? (
                    <a
                        href={`/${encodeURIComponent(sponsor.profileSlug)}`}
                        rel={SPONSORED_REL}
                    >
                        {sponsor.name}
                    </a>
                ) : (
                    sponsor.name
                )}
                {sponsor.role && `, ${sponsor.role}`}
                {firm && (
                    <>
                        {' at '}
                        {website ? (
                            <a href={website} rel={SPONSORED_REL}>
                                {firm}
                            </a>
                        ) : (
                            firm
                        )}
                    </>
                )}
            </p>
            {items.map(({ question, answer }) => (
                <div key={question} className={styles.expertAnswer}>
                    <h3>{question}</h3>
                    <p>{answer}</p>
                </div>
            ))}
            <p className={styles.expertAnswersNote}>
                These answers are general information, not financial advice.
            </p>
        </section>
    );
};

export default ExpertAnswers;
